/* The Lingerie Edit UK — product-page welcome offer repair. */
(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const isLegacyWelcome = (value) => {
    const text = normalize(value);
    const hasOldOffer = text.includes('welcome7') || text.includes('7%');
    const looksLikeOffer = text.includes('new here') || text.includes('first order') || text.includes('welcome offer') || text.includes('little welcome') || text.includes('enjoy');
    return hasOldOffer && looksLikeOffer;
  };

  const repairWelcomeOffer = () => {
    if (!document.querySelector('main[data-template^="product"]')) return;

    const candidates = Array.from(document.querySelectorAll('#MainContent p, #MainContent span, #MainContent div, #MainContent section, #MainContent aside'));
    let repaired = false;

    for (const element of candidates) {
      if (!isLegacyWelcome(element.textContent)) continue;

      const nestedLegacy = Array.from(element.children).some((child) => isLegacyWelcome(child.textContent));
      if (nestedLegacy) continue;

      element.innerHTML = 'New here? Enjoy <strong>10% off</strong> with <strong>WELCOME10</strong>';
      element.style.removeProperty('display');
      element.style.removeProperty('visibility');
      element.style.removeProperty('opacity');
      element.classList.add('tle-product-welcome-live');
      repaired = true;
    }

    const fallback = document.querySelector('.tle-welcome-offer');
    if (fallback) {
      fallback.hidden = repaired;
      fallback.style.display = repaired ? 'none' : '';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      repairWelcomeOffer();
      setTimeout(repairWelcomeOffer, 80);
    }, { once: true });
  } else {
    repairWelcomeOffer();
    setTimeout(repairWelcomeOffer, 80);
  }

  let timer;
  const observer = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length)) return;
    clearTimeout(timer);
    timer = setTimeout(repairWelcomeOffer, 60);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
